/**
 * Constants related to the Sidekick Chat History feature
 */

// CSS class name prefixes
export const SK_PREFIX = 'sk';
export const SK_CHAT_HISTORY_PREFIX = `${SK_PREFIX}-chat-history`;
export const SK_CHAT_DETAIL_PREFIX = `${SK_PREFIX}-chat-detail`;

// Component class names
export const SK_CHAT_HISTORY_CONTAINER_CLASS = `${SK_CHAT_HISTORY_PREFIX}-container`;
export const SK_CHAT_HISTORY_HEADER_CLASS = `${SK_CHAT_HISTORY_PREFIX}-header`;
export const SK_CHAT_HISTORY_TABLE_CLASS = `${SK_CHAT_HISTORY_PREFIX}-table`;
export const SK_CHAT_DETAIL_CONTAINER_CLASS = `${SK_CHAT_DETAIL_PREFIX}-container`;
export const SK_CHAT_DETAIL_HEADER_CLASS = `${SK_CHAT_DETAIL_PREFIX}-header`;

// Table column classes
export const TABLE_COLUMN_CLASSES = {
  EMAIL_ID: 'email-id-column',
  CONVERSATION_SUBJECT: 'conversation-subject-column',
  CONVERSATION_CREATED_AT: 'conversation-created-at-column',
  CONVERSATION_FEEDBACK: 'conversation-feedback-column',
  FEEDBACK_REASON: 'feedback-reason-column',
  CURATED_RESPONSES: 'curated-responses-column'
};

// Table column headers
export const TABLE_COLUMN_HEADERS = {
  EMAIL_ID: 'Email ID',
  CONVERSATION_SUBJECT: 'Conversation Subject',
  CONVERSATION_CREATED_AT: 'Conversation Created At',
  CONVERSATION_FEEDBACK: 'Conversation Feedback',
  FEEDBACK_REASON: 'Feedback Reason',
  CURATED_RESPONSES: 'Curated Response'
};

// Detail Table column classes
export const DETAIL_TABLE_COLUMN_CLASSES = {
  SENDER: 'sender-column',
  CONVERSATION: 'conversation-column',
  TIMESTAMP: 'timestamp-column',
  FEEDBACK: 'feedback-column',
  CITATIONS: 'citations-column'
};

// Detail Table column headers
export const DETAIL_TABLE_COLUMN_HEADERS = {
  SENDER: 'Sender',
  CONVERSATION: 'Conversation',
  TIMESTAMP: 'Timestamp',
  FEEDBACK: 'Feedback',
  CITATIONS: 'Citations'
};

// Feedback types
export const FEEDBACK_TYPES = {
  HELPFUL: 'Helpful',
  NOT_HELPFUL: 'Not Helpful',
  SKIP: 'Skip'
};

// Default pagination values
export const DEFAULT_ROWS_PER_PAGE = 10;
export const DEFAULT_CURRENT_PAGE = 1;

// HTTP status codes
export const UNAUTHORIZED_STATUS_CODE = 401;

// Generic error message for action failures
export const GENERIC_ACTION_ERROR_TITLE = 'We are unable to process this request.';
export const GENERIC_ACTION_ERROR_DESCRIPTION = 'Please refresh your page and try again.';

// Error and notification messages
export const INITIAL_LOAD_FAILURE_MESSAGE = 'Unable to load chat history.';
export const INITIAL_LOAD_FAILURE_MESSAGE_SESSION_DETAIL = 'Unable to load chat session.';
export const INITIAL_LOAD_FAILURE_DESCRIPTION = 'Please try again or refresh the page. If the issue persists, contact your Panviva administrator.';
export const UNAUTHORIZED_REDIRECT_MESSAGE = 'Token expired.';
export const UNAUTHORIZED_REDIRECT_DESCRIPTION = 'It looks like your token is expired or to be refreshed, You will be redirected to login again.';

// Table empty state messages
export const NO_CHAT_SESSION_FOUND = 'No Chat Session Found';
export const NO_RESULTS_MATCH_FILTERS = 'No results match your current filters';
export const ADJUST_FILTERS_MESSAGE = 'Try adjusting or removing some filters to see the results.';
export const SESSIONS_APPEAR_MESSAGE = 'Sessions will appear here as users interact with the Sidekick assistant.';

// Pagination options
export const ROWS_PER_PAGE_OPTIONS = [10, 20, 30, 40, 50, 100];

// Date filter preset options
export const DATE_PRESET_OPTIONS = [
  { value: 'previousDay', label: 'Previous Day' },
  { value: 'today', label: 'Today' },
  { value: 'last7Days', label: 'Last 7 Days' },
  { value: 'last14Days', label: 'Last 14 Days' },
  { value: 'last30Days', label: 'Last 30 Days' },
  { value: 'last60Days', label: 'Last 60 Days' },
  { value: 'last90Days', label: 'Last 90 Days' }
];